'use client'
import { useTranslations } from 'next-intl'
import ContactService from '@/app/services/send-message'
import { Send, Phone, Mail, User, MessageSquare, Tag } from 'lucide-react'
import { useState } from 'react'

const inputClassName =
  'w-full px-2 py-2 border border-color-primary text-black rounded-lg'

export default function ContactForm() {
  const t = useTranslations('Contact')
  const [isError, setIsError] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    const form = e.currentTarget
    const formData = new FormData(form)
    const payload = Object.fromEntries(formData.entries())

    try {
      const result = await ContactService.sendContactMessage(payload);
      if (result?.data?.success) {
        setIsSuccess(true);
        setIsError(false);
      }
    } catch (error: any) {
      setIsError(true);
      setIsSuccess(false);
    } finally {
      setIsLoading(false)
    }

  }

  return (
    <section className="pb-12 px-6">
      <div className="max-w-xl mx-auto">
        <div className="bg-white/5 backdrop-blur-md border border-color-primary rounded-lg py-4 sm:py-6 px-4 sm:px-6">
          <form onSubmit={handleSubmit} className="space-y-4 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div className="space-y-2">
                <div className="relative">
                  <input
                    placeholder={t('name')}
                    required
                    id="name"
                    name="name"
                    type="text"
                    className={inputClassName}
                  />
                </div>
              </div>

              <div className="space-y-2">
                <div className="relative">
                  <input
                    placeholder={t('email')}
                    required
                    id="email"
                    name="email"
                    type="email"
                    className={inputClassName}
                  />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div className="space-y-2">
                <div className="relative">
                  <input placeholder={t('phone')} id="phone" name="phone" type="tel" className={inputClassName} />
                </div>
              </div>

              <div className="space-y-2">
                <div className="relative">
                  <input
                    placeholder={t('subject')}
                    required
                    id="subject"
                    name="subject"
                    type="text"
                    className={inputClassName}
                  />
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="relative">
                <textarea
                  placeholder={t('message')}
                  required
                  id="message"
                  name="message"
                  rows={5}
                  className={`${inputClassName} resize-none pt-5`}
                />
              </div>
            </div>

            <button
              disabled={isLoading}
              type="submit"
              className="w-full flex items-center justify-center gap-3 py-4 bg-primary text-white font-semibold rounded-lg shadow-lg shadow-blue-900/40 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed">
              {isLoading ? (
                <div className="w-5 h-5 rounded-full animate-spin" />
              ) : (
                <>
                  {t('send')}
                  <Send size={18} />
                </>
              )}
            </button>
            {isSuccess ? <p className="text-center text-green-400 font-medium">{t('success')}</p> : null}
            {isError ? (
              <p className="text-center text-red-400 font-medium">
                {t('error')}
              </p>
            ) : null}
          </form>
        </div>
      </div>
    </section>
  )
}
